export const SET_ROUTE = "routeReducer/SET_ROUTE"


export const setRoute = (val) => (disptch) =>{
    return disptch({
        type: SET_ROUTE,
        payload: val
    });
}